
export const OWNER_NAME_STORAGE_KEY = 'cheddule.ownerName';

/** Stash the name chosen on the /signup screen so the wizard can open directly on the
 *  create-org step (the password was already set at signup). sessionStorage, like the
 *  password grant: it must not survive the tab. */
export function stashOwnerName(name: string): void {
  try {
    window.sessionStorage.setItem(OWNER_NAME_STORAGE_KEY, name);
  } catch {
    // sessionStorage unavailable: the wizard falls back to its set-password first step,
    // which harmlessly re-sets the password via the fresh /auth/me grant.
  }
}

export function readStashedOwnerName(): string | null {
  try {
    return window.sessionStorage.getItem(OWNER_NAME_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearStashedOwnerName(): void {
  try {
    window.sessionStorage.removeItem(OWNER_NAME_STORAGE_KEY);
  } catch {
  }
}
